<div class="modal-header">
  <h4 class="modal-title">{{ "com.add_edit_skill_title" | translate }}</h4>
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body add-edit-skill" ngbAutofocus>
  <myp-inline-loader [loading]="loading" height="200px" spinnerName="addEditSkill"></myp-inline-loader>

  @if (!loading) {
    <div>
      <span class="text-muted t-14">{{ "com.skills.skills_description" | translate }}</span>
      <br />
      @for (skillType of skillTypes; track skillType) {
        <h4 class="section-header m-b-10 m-t-20">
          {{ "com." + (skillType == "interest" ? "interests.interests" : skillType) | translate }}
          <span class="section-header-link" (click)="skillTypeMap[skillType].collapsed = !skillTypeMap[skillType].collapsed">
            {{ skillTypeMap[skillType].collapsed ? ("sphere.expand" | translate | uppercase) : ("sphere.collapse" | translate | uppercase) }}
            <fa-icon [icon]="skillTypeMap[skillType].collapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
          </span>
        </h4>
        @if (!skillTypeMap[skillType].collapsed) {
          <div class="skills-grid">
            @for (skill of skillTypeMap[skillType].skills; track skill) {
              <div class="community-skill-selector">
                <div class="checkbox">
                  <input type="checkbox" [(ngModel)]="skill.selected" />
                </div>
                <div class="option">
                  <div class="gothic m-b-5 pointer" (click)="skill.selected = !skill.selected">{{ "com.skills." + skill.string_id | translate }}</div>
                </div>
              </div>
            }
          </div>
        }
      }
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" [disabled]="loading" class="btn btn-primary" (click)="submit()">
    <span>{{ "general.submit" | translate }}</span>
  </button>
  <button type="button" class="btn btn-blank" (click)="activeModal.close('Close click')">{{ "general.close" | translate }}</button>
</div>
